import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import NoRecords from '../../components/style-guide/no-records/NoRecords';
import RequestReports from '../../components/style-guide/no-records/RequestReports';
import Box from '../../components/style-guide/box/Box';
import DocTile from './components/doc-tile/DocTile';
import GridLayout from './components/grid-layout/GridLayout';
import SearchBar from './components/search-bar/SearchBar';
import SkeletonGrid, { SkeletonDocTile } from './components/skeleton-grid/SkeletonGrid';
import InfiniteScroll from './components/infinity-scroll/InfinityScroll';
import {downloadFile, isNullOrUndefined, patentWithoutVerifier} from "../../shared";
import {Api, AppSettings} from "../../settings";
import FilterBar from "./components/filter-bar/FilterBar";
import clsx from "clsx";
import StorageService from "service/storage";

import styles from './MyReports.module.scss';

export const MyReports = props => {
    const { reports = [], searching = false, loading = false } = props;
    const docTileStyleCommon = 'mx-1 mx-md-3';
    const columnLayoutStyle = "";

    const handleDownload = useCallback((id, patent, type) => {
        if (isNullOrUndefined(id)) return;

        const cleanPatent = patentWithoutVerifier(patent);
        const reportName = type === "ANONYMOUS"
            ? `${cleanPatent.charAt(0)}XXXX${cleanPatent.charAt(cleanPatent.length - 1)}`
            : cleanPatent;

        downloadFile(Api.reportDownload(id), reportName);
    }, []);

    const handlePreview = useCallback((id) => {
        if (!isNullOrUndefined(id)) {
            window.open(Api.reportPreview(id), '_blank');
        }
    }, []);

    const handlePreviewInvoice = useCallback((id) => {
        const token = StorageService.getItem(AppSettings.ticketName);

        if (!isNullOrUndefined(id) && token) {
            window.open(Api.previewInvoice(id, token), '_blank');
        }
    }, []);

    const renderReports = () => {
        if (reports.length > 0) return (
            <GridLayout className={columnLayoutStyle}>
                {extraSmall =>
                    <InfiniteScroll>
                        {
                            reports.map((r, index) => (
                                <DocTile
                                    handleDownload={handleDownload}
                                    handlePreview={handlePreview}
                                    handlePreviewInvoice={handlePreviewInvoice}
                                    key={r.unique_id}
                                    id={r.unique_id}
                                    documentId={r.document_id}
                                    mltUid={r.mlt_uid}
                                    cavUid={r.cav_uid}
                                    creator={r.creator}
                                    tipo_reporte={r.tipo_reporte}
                                    comprobanteUid={r.comprobante_uid}
                                    className={clsx(docTileStyleCommon, extraSmall ? styles.dotTileExtraSmallViewport : styles.dotTileDefaultViewport)}
                                    patente={r.patente}
                                    emitDate={r.emitDate}
                                    statusMsg={r.statusMsg}
                                    percentage={r.progress}
                                    retryFailure={r.retryFailure}
                                />
                            ))
                        }
                        {
                            loading && (
                                <SkeletonDocTile style={{ width: extraSmall ? '80vw' : '200px', margin: 'auto' }} />)
                        }
                    </InfiniteScroll>
                }
            </GridLayout>
        );

        if (loading && reports.length === 0) {
            return <SkeletonGrid />;
        }

        if (searching && reports.length === 0) {
            return <NoRecords />
        } else if (!searching) {
            return <RequestReports />
        }
    };

    return (
        <Box className={props.className}>
            <SearchBar showRequestBtn={reports.length > 0 || (searching && reports.length === 0)} />
            <FilterBar />
            <Box id={'grid-container'} className="scrollbar scrollbar-sm-hidden mb-4">
                {renderReports()}
            </Box>
        </Box>
    );
};

MyReports.propTypes = {
    reports: PropTypes.array,
    loading: PropTypes.any,
    user: PropTypes.object,
    searching: PropTypes.any,
    actions: PropTypes.any
};

export default MyReports;
